module.exports = __webpack_public_path__ + "static/media/error-404.6ad37584.svg";